export default __webpack_public_path__ + "static/media/downRightArrow.dbaa52ef.png";